<div class="chip {{ chipSize }} {{ chipColor }} {{ chipClass }}" [ngClass]="{ 'chip-disabled': idDisabled, bordered: isBordered }">
  <!-- ICON -->
  @if (iconPath) {
    <img [src]="iconPath" [alt]="iconAltText" class="{{ iconClass }} chip-icon" (click)="onIcon($event)" />
  }
  <p class="chip-text">{{ chipText }}</p>
  <!-- Delete -->
  @if (isDeletable) {
    <img [src]="deleteIconPath" [alt]="deleteIconAltText" class="{{ deleteIconClass }} delete-icon" (click)="onDelete($event)" />
  }
</div>
